import { render, staticRenderFns } from "./FirstComponent.vue?vue&type=template&id=5eb82484&scoped=true"
import script from "./FirstComponent.vue?vue&type=script&lang=js"
export * from "./FirstComponent.vue?vue&type=script&lang=js"
import style0 from "./FirstComponent.vue?vue&type=style&index=0&id=5eb82484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb82484",
  null
  
)

export default component.exports